import { Button, Popover, Stack, Typography } from "@mui/material";
import { minutesToMilliseconds } from "date-fns";
import { useEffect, useState } from "react";
import { isAppUpdateAvailable, isAppUpdatePopupExpired, saveLastAppUpdatePopupTime } from "../services/appVersion";

interface Props {
  cooldownInMinutes: number;
}

const UpdateAppPopover = ({ cooldownInMinutes }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const openPopup = isAppUpdateAvailable() && isAppUpdatePopupExpired(minutesToMilliseconds(cooldownInMinutes));
    if (openPopup) {
      saveLastAppUpdatePopupTime();
    }
    // eslint-disable-next-line @eslint-react/set-state-in-effect
    setIsOpen(openPopup);
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, [window.location.pathname]);

  const handleUpdate = () => {
    saveLastAppUpdatePopupTime();
    window.location.reload();
  };

  return (
    <Popover
      open={isOpen}
      onClose={() => setIsOpen(false)}
      anchorPosition={{ top: 20, left: window.innerWidth - 20 }}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ "& .MuiPaper-root": { borderWidth: 1, borderStyle: "solid", borderColor: "primary.main" } }}
    >
      <Stack spacing={1} sx={{ py: 1, px: 1, width: "17rem", bgcolor: "background.grey" }}>
        <Typography variant="subtitle2" sx={{ textAlign: "center" }}>
          A new version of the app is available.
        </Typography>
        <Typography color="textSecondary" sx={{ textAlign: "center" }}>
          Please update to ensure it works correctly.
        </Typography>
        <Button variant="contained" onClick={handleUpdate}>
          Update
        </Button>
      </Stack>
    </Popover>
  );
};

export default UpdateAppPopover;
